<!--  -->
<template>
  <el-tooltip
    effect="dark"
    :content="content"
    placement="bottom"
    :disabled="disabled"
  >
    <!-- <svg-icon class="table-icon" :icon-class="iconClass"></svg-icon> -->
    <!-- 放入图标 -->
    <slot></slot>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {},
  computed: {
    disabled() {
      return !this.content;
    }
  }
};
</script>
<style scoped lang="less"></style>
